import React from 'react';
import {
    PhotoUploadPanel,
    PhotoUploadPanelProps,
} from '../../../../../generic/ui/FileUpload';
import { AppModal } from '../../../../../generic/ui/Modal';
import DriverModal from '../modals/DriverModal';
import PackageOverlay from '../modals/PackageOverlay';
import PackagesPortalModal from '../modals/PackagesPortalModal';
import ProblemHandleModal from '../modals/ProblemHandleModal';
import StatisticPackageModal from '../modals/StatisticPackageModal';
import { useDrivers } from '../services/DriversContext';

const PHOTO_ACCEPT = ['.png', '.jpg', '.jpeg'];
const PHOTO_MAX_SIZE_MB = 5;
const PHOTO_COMMENT_MAX_LENGTH = 500;

/**
 * Общий слой модалок модуля. Рендерится внутри DriversPageLayout.Page —
 * у AppModal Overlay position:absolute, ему нужен позиционированный предок.
 */
const DriversModals: React.FC = () => {
    const {
        target: photoTarget,
        closePhotoUpload,
        uploadPhoto,
        isOpenProblemModal,
        handleIsOpenProblemModal,
        problemModalProps,
        isOpenStatisticModal,
        handleOpenPackageStatisticModal,
        kavInfo,
        packageLogProps,
        isOpenPortalModal,
        handlePortalModal,
        portalModalProps,
        listPacakgesActions,
        isOpenPackageOverlay,
        handleIsOpenPackageOverlay,
        saveToLogPackage,
        refetch,
        isOpenDriverModal,
        handleControlFuncModal,
        descForDriverModal,
        driverModalProps,
    } = useDrivers();


    const photoPanelProps: PhotoUploadPanelProps = {
        accept: PHOTO_ACCEPT,
        maxSizeMb: PHOTO_MAX_SIZE_MB,
        commentLabel: 'הערה',
        commentPlaceholder: 'אפשר לשלוח הערה גם בלי תמונה',
        commentMaxLength: PHOTO_COMMENT_MAX_LENGTH,
        onUpload: uploadPhoto,
    };

    return (
        <>
            {photoTarget && (
                <AppModal
                    title={`העלאת תמונה / הערה - ${photoTarget.ObjectID}`}
                    Children={PhotoUploadPanel}
                    controlFunc={closePhotoUpload}
                    childrenProps={photoPanelProps}
                    size='md'
                />
            )}

            {isOpenProblemModal && (
                <AppModal
                    title='איסוף החזרה'
                    controlFunc={handleIsOpenProblemModal}
                    childrenProps={problemModalProps}
                    Children={ProblemHandleModal}
                    size='md'
                />
            )}

            {isOpenStatisticModal && (
                <AppModal
                    title={`סיכום אריזות ל${kavInfo?.AreaDesc?.trim()} `}
                    controlFunc={handleOpenPackageStatisticModal}
                    childrenProps={packageLogProps}
                    Children={StatisticPackageModal}
                    size='md'
                />
            )}

            {isOpenPortalModal && (
                <AppModal
                    title={listPacakgesActions?.at(0)?.Description?.trim() || ''}
                    controlFunc={handlePortalModal}
                    childrenProps={portalModalProps}
                    Children={PackagesPortalModal}
                    size='md'
                />
            )}

            {isOpenPackageOverlay && (
                <PackageOverlay
                    getDriverDate={refetch}
                    saveToLogPackage={saveToLogPackage}
                    controlFunc={handleIsOpenPackageOverlay}
                />
            )}

            {isOpenDriverModal && (
                <AppModal
                    title={descForDriverModal}
                    controlFunc={handleControlFuncModal}
                    childrenProps={driverModalProps}
                    Children={DriverModal}
                    size='md'
                />
            )}
        </>
    );
};

export default DriversModals;
